<template>
	<v-dialog v-model="showDialog" max-width="600px">
		<v-card>
			<h2 class=v-card__title v-text=title></h2>
			<v-layout align-center justify-center>
				<v-btn to='../register/register_coworker' v-text=addCoworkerButtonName></v-btn>
				<v-btn to='../register/register_subsidiary' v-text=addSubsidiaryButtonName></v-btn>
			</v-layout>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "AddSubBidderMenu",

    watch: {
      dialog(val) {
        this.showDialog = val;
      },

      showDialog(val) {
        if (!val) {
          this.$emit('close-dialog');
        }
      }
    },

    props: {
      dialog: {
        type: Boolean, default: false
      }
    },

		data() {
			return {
				title: "Dodaj subkonto",
				addCoworkerButtonName: "Pracownik",
				addSubsidiaryButtonName: "Podmiot zależny",
        showDialog: false
			};
		},
	};
</script>

<style scoped>
	.justify-center {
		height: 100px;
	}

	.application.mediumFont .v-dialog .v-dialog--active {
		max-width: 750px !important;
	}

	.application.largeFont .v-dialog--active {
		max-width: 750px !important;
	}
</style>